import { trackStructuredEvent } from 'js/helpers/google-tag-manager';

export function trackVenueAction(action: string): void {
  trackStructuredEvent({
    category: 'quick_view_button',
    property: action,
    action: 'select',
  });
}
